import { Types } from "common/createjs";
import { noop } from "common/functions";
import { smartVideo as smartVideoLoader } from "common/loader";
import * as R from "ramda";
import { resourcePaths, soundFilePath } from "./scene/resources";
import { loadSound } from "./scene/sound";
export async function load({ progressCallback }) {
    let audioSrc = null;
    await smartVideoLoader.load({
        files: [
            ...R.map((path) => {
                return {
                    name: "normal",
                    path,
                    onComplete: noop,
                    onProgress: noop,
                };
            }, resourcePaths),
            {
                name: "normal",
                path: { src: soundFilePath, type: Types.SOUND },
                onComplete: (ev) => {
                    const element = ev.result;
                    audioSrc = element.src;
                },
                onProgress: noop,
            },
        ],
        xhrAllProgress: (progress) => {
            progressCallback(progress);
        },
    });
    const sound = await loadSound(audioSrc);
    return sound;
}
//# sourceMappingURL=loader.js.map